/**
 * [BL] Landing pages: buttons that point at a section on the same page (href="#who") glide there slowly
 * instead of jumping, landing just under the sticky header (the target's scroll-margin-top). Loaded by
 * [BL] Ad Hero, so it covers the hero, floating and in-page buttons on ad pages. Reduced motion: a plain jump.
 */
const DURATION = 900;

const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

/**
 * What scrolls the page. On desktop the theme locks html/body (`overflow: hidden`) and scrolls `.page-wrapper`
 * instead, so moving the window does nothing there.
 * @returns {HTMLElement}
 */
function pageScroller() {
  const root = /** @type {HTMLElement} */ (document.scrollingElement || document.documentElement);
  const wrapper = /** @type {HTMLElement | null} */ (document.querySelector('.page-wrapper'));
  const windowScrolls = getComputedStyle(document.documentElement).overflowY !== 'hidden' && root.scrollHeight > root.clientHeight;
  return !windowScrolls && wrapper && wrapper.scrollHeight > wrapper.clientHeight ? wrapper : root;
}

function glideTo(target) {
  const scroller = pageScroller();
  const isRoot = scroller === document.scrollingElement || scroller === document.documentElement;
  const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
  const offset = isRoot ? 0 : scroller.getBoundingClientRect().top;
  const start = scroller.scrollTop;
  const end = Math.max(0, start + target.getBoundingClientRect().top - offset - margin);
  const distance = end - start;
  const began = performance.now();
  const previous = scroller.style.scrollBehavior;
  scroller.style.scrollBehavior = 'auto';

  const step = (now) => {
    const progress = Math.min(1, (now - began) / DURATION);
    scroller.scrollTop = start + distance * ease(progress);
    if (progress < 1) requestAnimationFrame(step);
    else scroller.style.scrollBehavior = previous;
  };
  requestAnimationFrame(step);
}

if (!window.blSmoothAnchor) {
  window.blSmoothAnchor = true;
  document.addEventListener('click', (event) => {
    const link = /** @type {Element} */ (event.target).closest?.('a[href^="#"]');
    if (!(link instanceof HTMLAnchorElement) || event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const id = decodeURIComponent(link.getAttribute('href')?.slice(1) || '');
    const target = id && document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.scrollIntoView();
    } else {
      glideTo(target);
    }
    history.replaceState(null, '', `#${id}`);
  });
}
